import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';

const WEBHOOK_URL = 'https://n8n.rvcarbon.com.br/webhook/72ea20b5-aa6a-4f46-915b-b4903567ad1c/chat';

type ChatEvent = { type: string; content?: string };



async function streamChat(
    { sessionId, chatInput }: { sessionId: string; chatInput: string },
    onChunk: (content: string) => void
) {
    const response = await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId, action: 'sendMessage', chatInput }),
    });

    if (!response.ok || !response.body) {
        throw new Error(`Erro no webhook: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    const handleLine = (line: string) => {
        const normalizedLine = line.replace(/^\s*data:\s?/, '').trim();
        if (!normalizedLine) return;

        try {
            const event: ChatEvent = JSON.parse(normalizedLine);

            if (event.type === 'item' && event.content) {
                onChunk(event.content);
            }
        } catch (e) {
            console.warn(e)
        }
    };

    while (true) {
        const { value, done } = await reader.read();

        if (done) {
            break;
        }

        buffer += decoder.decode(value, { stream: true });

        const lines = buffer.split('\n');
        buffer = lines.pop() ?? '';

        for (const line of lines) {
            handleLine(line);
        }
    }

    buffer += decoder.decode();

    if (buffer.trim()) {
        handleLine(buffer);
    }
}

export function useChatStream(sessionId: string) {
    const [output, setOutput] = useState('');

    const mutation = useMutation({
        mutationFn: (chatInput: string) => {
            setOutput('');
            return streamChat({ sessionId, chatInput }, (chunk) =>
                setOutput((prev) => prev + chunk)
            );
        },
    });

    return {
        output,
        sendMessage: mutation.mutate,
        isStreaming: mutation.isPending,
        error: mutation.error,
    };
}
